import { Injectable, signal } from '@angular/core';
 
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _modals = new Map<string, ReturnType<typeof signal<boolean>>>();
  private _modalData = new Map<string, ReturnType<typeof signal<any>>>();
 
  /**
   * Obtiene o crea un signal para un modal específico
   */
  private getModalSignal(modalId: string) {
    if (!this._modals.has(modalId)) {
      this._modals.set(modalId, signal(false));
    }
    return this._modals.get(modalId)!;
  }
 
  /**
   * Obtiene o crea un signal para los datos de un modal específico
   */
  private getModalDataSignal(modalId: string) {
    if (!this._modalData.has(modalId)) {
      this._modalData.set(modalId, signal(null));
    }
    return this._modalData.get(modalId)!;
  }
 
  /**
   * Abre un modal
   */
  openModal(modalId: string, data?: any) {
    const modalSignal = this.getModalSignal(modalId);
    modalSignal.set(true);
 
    if (data) {
      const dataSignal = this.getModalDataSignal(modalId);
      dataSignal.set(data);
    }
  }
 
  /**
   * Cierra un modal
   */
  closeModal(modalId: string) {
    const modalSignal = this.getModalSignal(modalId);
    modalSignal.set(false);
 
    // Limpiar datos al cerrar
    const dataSignal = this.getModalDataSignal(modalId);
    dataSignal.set(null);
  }
 
  /**
   * Obtiene el signal de visibilidad de un modal
   */
  isVisible(modalId: string) {
    return this.getModalSignal(modalId).asReadonly();
  }
 
  /**
   * Obtiene el signal de datos de un modal
   */
  getData(modalId: string) {
    return this.getModalDataSignal(modalId).asReadonly();
  }
}